import React, { useState } from "react";
import {
  Button,
  TextField,
  Container,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          py: 2.2,
          borderTop: `1px solid #ffffff33`,
          // background: "rgba(0, 0, 0, 0.46)",
          width: "100%",
        }}
      >
        <Box component="a" href={""} className="footer">
          <Typography
            variant="span"
            component="span"
            className=""
            sx={{ color: "#c5c5c5 !important" }}
          >
            © 2026 MyNetGoals . All rights reserved.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
